<template>
  <!-- 搜索时的页面 -->
  <div :class="type == 1 ? 'mtType1' : 'mtType2'">
    <!-- 搜索记录 -->
    <div v-if="history" class="history-wrap">
      <div v-if="!historydata || !historydata.length" class="history-empty">
        <van-empty description="暂无搜索记录" image="search" />
      </div>
      <div v-else class="history-card">
        <div class="history-card__header">
          <span class="history-card__title">搜索历史</span>
          <button type="button" class="history-card__clear" @click="localDelete">
            <van-icon name="delete-o" size="0.9rem" />
            清空
          </button>
        </div>
        <div class="history-tags">
          <button
            v-for="item in historydata"
            :key="item"
            type="button"
            class="history-tag"
            @click="reSeach(item)"
          >
            {{ item }}
          </button>
        </div>
      </div>
    </div>

    <!-- 搜索结果 -->
    <div v-else class="search-result-wrap">
      <div v-if="zyData.length === 0" class="search-result-empty">
        <van-empty class="custom-image empty" description="暂无相关商品" />
      </div>
      <van-list
        v-else
        v-model="loading2"
        :finished="finished"
        finished-text="没有更多了"
        @load="nextPage"
      >
        <goods-list-com :DataList="zyData" />
      </van-list>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import GoodsListCom from "../../components/GoodsListCom.vue";
export default {
  name: "",
  props: {
    value: {
      type: String,
    },
    type: {
      type: Number
    },
    id: {
      type: Number
    },
    hotType: {
      type: String
    }
  },
  data() {
    return {
      loading2: false, // 商品列表是否处于加载状态
      finished: false, // 是否加载完了
      // 搜索历史
      history: true,
      // 数据
      historydata: null,
      zyData: [],
      zyform: {
        cardId: '',
        current: 1, // 当前页码
        size: 10, // 每页个数
        productName: '',
        cityCode: '',
        upgradeFlag: localStorage.getItem("upgradeFlag"),
        bathId: localStorage.getItem("bathId"),
        id: undefined,
        hotType: undefined,
        priceType: null,
        productType: undefined,
      },
      //
      username: null,
    };
  },
  components: { GoodsListCom },
  methods: {
    /** 礼包商城搜索仅查礼包商品（type=10） */
    applyGiftProductTypeFilter() {
      if (localStorage.getItem('mallSource') === 'giftPackage') {
        this.zyform.productType = '10'
      } else {
        this.zyform.productType = undefined
      }
    },
    getTabIndex(index) {
      this.tabindexL = index
    },
    // 获取搜索记录
    getHistroy() {
      // 登陆获取用户的搜索记录
      if (this.username) {
        this.historydata = JSON.parse(
          localStorage.getItem(`${this.username}seachHistory`)
        );
      } else {
        // 没有登陆获取公共的记录
        // 获取本地存储记录
        this.historydata = JSON.parse(localStorage.getItem("seachHistory"));
      }
    },

    // 清除本地数据
    localDelete() {
      let key;
      if (this.username) {
        key = `${this.username}seachHistory`;
      } else {
        key = "seachHistory";
      }
      if (localStorage.getItem(`${key}`) === null) {
        return;
      } else {
        localStorage.removeItem(`${key}`);
      }
      this.historydata = null;
    },
    // 点击关键字搜索
    seach(val) {
      if (!Boolean(val)) {
        Toast.fail("未输入关键字");
        this.history = true;
      } else {
        Toast.loading({
          message: "加载中...",
          forbidClick: true,
          loadingType: "spinner",
          duration: "1000",
        });
        this.zyform.productName = val
        // 重置分页与列表状态，避免上一次滚动到第N页后仍按第N页查询
        this.zyform.current = 1
        this.finished = false
        this.loading2 = false
        this.zyData = []
        if (this.id) {
          this.zyform.id = this.id
        }
        if (this.hotType) {
          this.zyform.hotType = this.hotType
        }
        //自营商品
        this.getData('search')
        if (this.username) {
          this.$utils.saveHistory({
            key: `${this.username}seach`,
            data: val,
          });
        } else {
          // 添加本地储存记录
          this.$utils.saveHistory({ key: "seach", data: val });
        }
      }
    },
    setPriceType(val) {
      this.zyform.priceType = val
      this.zyform.current = 1
      this.getData()
    },
    getData(type) {
      this.applyGiftProductTypeFilter()
      this.$api
        .queryProductInfoHomeNew(this.zyform)
        .then((res) => {
          if (res.code == 1) {
            Toast(res.msg);
            return;
          }
          this.history = false;
          if (this.zyform.current == 1) {
            this.zyData = res.data.records;
          } else {
            if(type === 'search'){
              this.zyData = res.data.records;
            }else {
              this.zyData.push(...res.data.records);
            }
            
          }
          if (this.zyData.length > 0) {
            this.showTop()
          }
          this.loading2 = false;
          if (this.zyform.current >= res.data.pages) {
            this.finished = true;
          }
          // 登陆存储该用户的搜索关键字  未登录粗存游客搜索的记录
        })
        .catch((err) => {
          console.log(err);
        });
    },

    nextPage() {
      // 加载下一页
      if (this.zyData.length >= 10) {
        this.loading = false;
        this.zyform.current += 1;
        this.getData();
      }
    },
    showTop() {
      this.$emit("showtop");
    },
    // 点击历史再次搜索
    reSeach(val) {
      this.seach(val);
      this.$emit("value", val);
    },
    reset() {
      this.loading2 = false
      this.finished = false
      this.history = true
      this.historydata = null
      this.zyData = []
      this.zyform = {
        cardId: localStorage.getItem('cardId'),
        current: 1, // 当前页码
        size: 10, // 每页个数
        productName: '',
        cityCode: localStorage.getItem('cityCode'),
        upgradeFlag: localStorage.getItem("upgradeFlag"),
        bathId: localStorage.getItem("bathId"),
        id: undefined,
        priceType: null,
        hotType: undefined,
        productType: undefined,
      },
        //
        localStorage.getItem("userInfo")
          ? (this.username = JSON.parse(localStorage.getItem("userInfo")).username)
          : "";
      this.applyGiftProductTypeFilter();
      this.getHistroy();
    }
  },

  mounted() {
    localStorage.getItem("userInfo")
      ? (this.username = JSON.parse(localStorage.getItem("userInfo")).username)
      : "";
    this.zyform.cardId = localStorage.getItem('cardId')
    this.zyform.cityCode = localStorage.getItem('cityCode')
    this.applyGiftProductTypeFilter()
    this.getHistroy();
  },
  computed: {},
  watch: {
    // 输入框的值为空时
    value() {
      if (!this.value) {
        this.history = true;
        this.getHistroy();
      }
    },

    '$route': function () {
      this.$waterfall.forceUpdate()

    },
  },
};
</script>

<style lang='scss' scoped>
.container-water-fall {

  /* // padding: 0 28px; */
  padding: 0 3%;
  width: 100vw;
  box-sizing: border-box;
  /* background: #fafafa !important; */
}

.cell-item {
  background: #ffffff;
  border-radius: 10px;
  overflow: hidden;
  box-sizing: border-box;
  margin: 5% 0;
}

.cell-item img {
  width: 100%;
  height: auto;
  display: block;
}

.his {
  height: 20px;
  line-height: 20px;
  margin: 5px 10px;
  background-color: rgba(224, 221, 221, 0.5);
}

.history-wrap {
  padding: 0.75rem;
}

.history-empty {
  padding: 2.5rem 0 3rem;
  background: #fff;
  border-radius: 0.75rem;
  margin-top: 0.25rem;
}

.history-card {
  background: #fff;
  border-radius: 0.75rem;
  padding: 0.875rem 0.875rem 0.625rem;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.75rem;
  }

  &__title {
    font-size: 0.9rem;
    font-weight: 600;
    color: #333;
  }

  &__clear {
    display: inline-flex;
    align-items: center;
    gap: 0.15rem;
    padding: 0;
    border: none;
    background: transparent;
    font-size: 0.75rem;
    color: #999;
    cursor: pointer;
  }
}

.history-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.history-tag {
  max-width: 100%;
  padding: 0.35rem 0.75rem;
  border: none;
  border-radius: 1rem;
  background: #f5f6f7;
  font-size: 0.8rem;
  line-height: 1.4;
  color: #555;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:active {
    background: #eceef0;
  }
}

.search-result-wrap {
  min-height: 50vh;
}

.search-result-empty {
  padding: 2rem 0 3rem;
  background: #fff;
  margin: 0.5rem 0.75rem 0;
  border-radius: 0.75rem;
}

.mtType1 {
  padding-top: 0.3rem;
}

.mtType2 {
  padding-top: 0.25rem;
  padding-bottom: 4rem;
}

.price {
  color: #f00;
  margin-left: 0.5rem;
  font-size: 1rem;
  padding-bottom: 0.2rem;
}

.seach-img {
  width: 20%;
}
</style>